// extracted by mini-css-extract-plugin
export default {"container":"loginPage_container__fj8Ab"};